import { render } from "./doorwallsystem.vue?vue&type=template&id=7a37c435"
import script from "./doorwallsystem.vue?vue&type=script&lang=js"
export * from "./doorwallsystem.vue?vue&type=script&lang=js"

import "./doorwallsystem.vue?vue&type=style&index=0&id=7a37c435&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__